<template>
  <div
    :class="
      $router.currentRoute.name !== 'planification'
        ? 'general-container'
        : 'global-container'
    "
  >
    <!-- v-if="$store.state.login.token">-->
    <loading-image-modal ref="loading-modal" />
    <TutorialModal ref="tutorial-modal" />
    <FeedbackButtonComponent ref="feedback-modal" />
    <MakeTestModal ref="make-test-modal" />
    <RedpieTutorialModal ref="redpie-tutorial-modal" />
    <SetCountryModal ref="country-modal" v-on:get-posts="force_get_posts" />
    <b-modal ref="message-modal" hide-footer hide-header no-close-on-backdrop>
      <b-container>
        <b-row>
          {{ message }}
        </b-row>
        <b-row>
          <b-img :src="saveAsImg" fluid />
        </b-row>
        <b-row>
          <b-col class="text-center">
            <b-button variant="primary" pill @click="closeAndUpdate">
              Entendido!
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <!-- <SidebarComponent class="d-none d-xl-inline d-lg-inline d-md-inline">
      <TutorialComponent v-on:get-filtered-posts="get_posts_by_subtag"/>
    </SidebarComponent> -->
    <!-- En la portada sin sesión manda la cabecera de la portada. v-show y no
         v-if: al montarse registra `openLogin`, que la portada usa. -->
    <HeaderComponent
      v-show="!portadaSinSesion"
      style="z-index: 999"
      v-on:search-by-text="search_by_text"
      v-on:set-not-new-notifications="set_not_new_notifications"
      v-on:load-notifications="get_my_previous_notifications"
      @set-open-login-fun="setOpenLogin"
      @hidden="checkAndChange"
    />
    <div
      style="background-color: white !important;"
      class="mx-0"
      :class="{ 'header-margin': !portadaSinSesion }"
    >
      <info-banner
        v-if="!esPortada"
        :backgroundImg="mainBanner"
        :backgroundImgCell="mainCell"
        orientation="left"
        :offset="3"
        :colsMD="10"
        paddingTop="4vw"
        title="Utopie, el software más avanzado al servicio de la educación"
        text="Tú trabajas con los niños, nosotros hacemos el resto."
        txtColor="black"
        titleSize="3.5vw"
        titleSizeCell="9vw"
        paddingTopTextCell="20vw"
      />
      <b-container
        v-show="!esPortada"
        ref="buttons"
        class="p-0"
        fluid
        style="overflow-x: hidden"
        id="buttons"
      >
        <b-row class="d-none d-md-flex">
          <b-col
            v-for="(option, oIndex) in options"
            :key="oIndex + '-option'"
            class="text-center"
            :class="
              option.mode === 'redpie' && !$store.state.login.isPaid ? '' : ''
            "
          >
            <div class="text-center d-block mt-4">
              <b-img
                :src="option.icon"
                class="menu-button"
                :class="{ 'menu-button-active': isOptionActive(option.mode) }"
                :style="'width: ' + option.width"
                :title="
                  isOptionActive(option.mode) ? 'Volver al inicio' : option.name
                "
                @click="bubbleClick(option.mode)"
              />
            </div>
            <strong class="d-none d-md-block mt-3" style="font-size: 2vw">
              <p v-html="option.name" />
            </strong>
          </b-col>
        </b-row>
        <b-row class="d-flex d-md-none">
          <b-col
            v-for="(option, oIndex) in options"
            :key="oIndex + '-option'"
            class="text-center"
            :class="
              (option.hideOnCell ? 'd-none' : '') +
              (option.mode === 'redpie' && !$store.state.login.isPaid ? '' : '')
            "
            :cols="option.hideOnCell ? 0 : ''"
          >
            <div class="text-center d-block mt-4">
              <b-img
                :src="option.icon"
                class="menu-button"
                :class="{ 'menu-button-active': isOptionActive(option.mode) }"
                :style="'width: ' + option.widthCell"
                @click="bubbleClick(option.mode)"
              />
            </div>
            <strong class="d-block d-md-none mt-3" style="font-size: 15px">
              <p v-html="option.name" />
            </strong>
          </b-col>
        </b-row>
      </b-container>
      <InvitationBanner @open-login="openLogin && openLogin(true)" />
      <TicketBanner @open-login="openLogin && openLogin(true)" />
      <PromoCodeBanner @open-login="openLogin && openLogin(true)" />
      <transition name="slide-fade" mode="out-in">
        <!-- La portada se queda viva al ir a un servicio: montarla de nuevo
             (marcado, hoja y las 26 animaciones) tomaba medio segundo en PC
             y más de uno en un celular, cada vez que se volvía al inicio. -->
        <keep-alive include="LandingPage" :max="1">
          <router-view
            ref="main"
            :tags="tags"
            :bannerLoaded="bannerLoaded"
            :key="reload"
            :routeName="service"
            class="main-component"
            @view-file="view_file"
            @points-change="reload_points"
            @create-school="createSchool"
            @create-school-docs="createSchoolDocs"
            @open-test-modal="$refs['make-test-modal'].open()"
            @toggle-reload="reload = !reload"
            @try="changeView"
            @learn-more="goToServices"
            @open-login="openLoginTrial"
          />
        </keep-alive>
      </transition>
      <contact-us id="contact" ref="contact" :route="service"></contact-us>
    </div>
    <b-modal id="bv-modal-view-file" size="xl" hide-footer>
      <template v-slot:modal-title>
        <b-spinner
          variant="success"
          type="grow"
          label="Spinning"
          v-if="rate_loading"
        />
        <star-rating
          v-model="bound_rating"
          @rating-selected="rating_selected"
          v-else
        />
      </template>
      <iframe :src="view_link" class="w-100" style="height: 66vh" />
      <a :href="download_link">
        <b-button variant="info" class="mt-1" @click="downloaded" block
          >Descargar</b-button
        >
      </a>
    </b-modal>
    <!-- <BottomButton class="d-block d-md-none" /> -->
  </div>
</template>

<script>
import authService from "../../services/authService";
import FeedbackButtonComponent from "../../components/utopie/modals/FeedbackButtonComponent";
import HeaderComponent from "../../components/utopie/miscellaneous/HeaderComponent";
import TagsAndSubtags from "../../components/utopie/miscellaneous/TagsAndSubtags";
import Banner from "../../components/utopie/miscellaneous/Banner";
import notificationService from "../../services/notificationService";
import missionService from "../../services/missionService";
import fileService from "../../services/fileService";
import postService from "../../services/postService";
import userService from "../../services/userService";
import ProfileSidebarComponent from "../../components/utopie/miscellaneous/ProfileSidebarComponent";
import RightSidebarComponent from "../../components/utopie/miscellaneous/RightSidebarComponent";
import SidebarComponent from "../../components/utopie/miscellaneous/SidebarComponent";
import TagComponent from "../../components/utopie/miscellaneous/TagComponent";
import TutorialComponent from "../../components/utopie/miscellaneous/TutorialComponent";
import TagsAndSubtags2 from "../../components/utopie/imported/TagsAndSubtags";
import TutorialModal from "../../components/utopie/modals/TutorialModal";
import SiteLoginComponent from "../../components/utopie/miscellaneous/SiteLoginComponent";
import { event } from "vue-gtag";
import { conProducto, eventoLogin } from "@/services/analytics";
import { olvidarOrigenLogin } from "@/services/origen";
import SetCountryModal from "../../components/utopie/modals/SetCountryModal";
import MakeTestModal from "../../components/utopie/modals/MakeTestModal";
import BottomButton from "../../components/utopie/miscellaneous/BottomButton";
import RedpieTutorialModal from "../../components/redpie/modals/TutorialModal";
// import redpieService from "../../services/redpieService";
import LoadingImageModal from "../../components/utopie/modals/LoadingImageModal";
import ContactUs from "@/components/sales/miscellaneous/ContactUs";
import InfoBanner from "@/components/utopie/miscellaneous/InfoBanner";
import InvitationBanner from "@/components/botpie-assistant/InvitationBanner";
import TicketBanner from "@/components/botpie-assistant/TicketBanner";
import PromoCodeBanner from "@/components/botpie-assistant/PromoCodeBanner";
import { preloadImages } from "@/components/utopie/utils/preloadImages";
import { scrollBelowServiceBubbles } from "@/utils/scrollToTop";

export default {
  components: {
    HeaderComponent,
    InvitationBanner,
    TicketBanner,
    PromoCodeBanner,
    FeedbackButtonComponent,
    TutorialComponent,
    SidebarComponent,
    ProfileSidebarComponent,
    TagComponent,
    TagsAndSubtags,
    RightSidebarComponent,
    TagsAndSubtags2,
    SiteLoginComponent,
    TutorialModal,
    BottomButton,
    SetCountryModal,
    RedpieTutorialModal,
    MakeTestModal,
    Banner,
    LoadingImageModal,
    ContactUs,
    InfoBanner,
  },
  computed: {
    headerHeight() {
      let element = document.querySelector("#header");
      if (element) {
        let height = element.offsetHeight;
        return height;
      }
      return 0;
    },
    token() {
      return this.$store.state.login.token;
    },
    // La portada (LandingPage) trae su propio hero y sus productos.
    esPortada() {
      return !!this.$route.meta.landing;
    },
    portadaSinSesion() {
      return this.esPortada && !this.token;
    },
  },
  created() {
    const vue_scope = this;
    userService.get_user_data().then((data) => {
      this.$store.commit("login/setUser", data, { root: true });
      if (data.message) {
        this.message = data.message;
        this.$refs["message-modal"].show();
      }
    });
    if (this.$store.state.login.token) {
      this.verify_token();
      this.$connect();
      userService.get_user_data().then((data) => {
        this.$store.commit("login/setUser", data, { root: true });
        this.check_country();
        if (data.message) {
          this.message = data.message;
          this.$refs["message-modal"].show();
        }
      });
    } else {
      // const current_date = new Date().valueOf().toString();
      // const random = Math.random().toString();
      // this.$store.commit(
      //   "login/setAnonID",
      //   (current_date + random).replace(".", ""),
      //   { root: true }
      // );
      // this.$connect(process.env.VUE_APP_SOCKET_URL + `/ws/socket/?token=${this.$store.state.login.anonID}`);
    }
    this.get_new_notifications();
    this.get_my_notifications();
    this.getUncompletedMissions();
    this.get_tags();
    this.$options.sockets.onmessage = (payload) => {
      let data = JSON.parse(payload.data).message;
      if (!data) {
        data = JSON.parse(payload.data);
      }
      if (data && data.kind === "notification") {
        vue_scope.$toasted.success(data.text).goAway(1500);
        this.get_new_notifications();
        this.get_my_last_notifications();
      }
      if (data && data.kind === "mission_completed") {
        this.$store.state.login.missions.filter(
          (m) => m.mission.mission_code === data.mission
        )[0].completed = true;
        userService.get_user_data().then((data) => {
          this.$store.commit("login/setUser", data, { root: true });
        });
      }
      if (data && data.type === "school_created") {
        this.$store.commit("login/setSchool", data.school, { root: true });
        if (this.redirect_to_tests) {
          this.redirect_to_tests = false;
          window.location.href = "/redpie#/tutorial-tests";
        } else if (this.redirect_to_docs) {
          this.redirect_to_docs = false;
          window.location.href = "/redpie#/tutorial-docs";
        } else {
          window.location.href = "/redpie#/tutorial";
        }
      }
      if (data && data.type === "planifications_uses_update") {
        this.$store.commit("login/setPlanificationsUses", data.planifications_uses);
        this.$store.commit("login/setMaterialsUses", data.materials_uses);
        this.$store.commit("login/setTestsUses", data.tests_uses);
        this.$store.commit("login/setDocumentsUses", data.documents_uses);
      }
    };
    // eslint-disable-next-line
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      this.view_link = "";
      this.download_link = "";
    });
    if (process.browser) {
      window.addEventListener("resize", this.set_main_container_position, {
        passive: true,
      });
      this.set_main_container_position();

      this.$nextTick(() => {
        this.set_main_container_position();
      });
    }
    this.preloadMainBanner();
  },
  mounted() {
    this.set_main_container_position();
    this.openLoginFromQuery();
  },
  data: function () {
    return {
      reload: false,
      bannerLoaded: false,
      mode: "landing",
      mainBanner: require("@/assets/img/landing_page/PNG/web/Principal.png"),
      mainCell: require("@/assets/img/landing_page/PNG/cell/Principal.png"),
      eurekaBanner: require("@/assets/img/landing_page/PNG/Landing Page_Banner sin botón_Eureka@4x.png"),
      planificationsBanner: require("@/assets/img/landing_page/PNG/Landing Page_Banner sin botón_Planificaciones@4x.png"),
      pieBanner: require("@/assets/img/landing_page/PNG/Landing Page_Banner sin botón_Mi Colegio@4x.png"),
      materialsBanner: require("@/assets/img/landing_page/PNG/Landing Page_Banner sin botón_Materiales@4x.png"),
      options: [
        {
          name: "Eureka",
          icon: require("@/assets/img/landing_page/Iconos/Ícono_Eureka copia@4x.png"),
          mode: "eureka",
          redirect: "/comprar#/eureka",
          width: "100px",
          widthCell: "70px",
        },
        {
          name: "Planificación<br/>de clase",
          icon: require("@/assets/img/landing_page/Iconos/Ícono_planif clases copia@4x.png"),
          mode: "planification",
          redirect: "/comprar#/planification",
          width: "100px",
          widthCell: "70px",
        },
        {
          name: "Materiales<br/>para la clase",
          icon: require("@/assets/img/landing_page/Iconos/Icono_Materiales_clase.svg"),
          mode: "class-materials",
          redirect: "/comprar#/",
          width: "100px",
          widthCell: "70px",
        },
        {
          name: "Pruebas<br/>Informales",
          icon: require("@/assets/img/landing_page/Iconos/Ícono_materiales interactivos copia@4x.png"),
          mode: "materials",
          redirect: "/comprar#/materials",
          width: "100px",
          widthCell: "70px",
        },
        {
          name: "Corregir<br/>TEST",
          icon: require("@/assets/img/landing_page/Iconos/Corregir_TEST.png"),
          mode: "test-correction",
          redirect: "/comprar#/corregir-test",
          width: "100px",
          widthCell: "70px",
        },
        {
          name: "Documentos<br/>PIE",
          // TODO: replace with a dedicated individual-documents icon.
          icon: require("@/assets/img/landing_page/Iconos/Documentos_PIE.png"),
          mode: "individual-documents",
          redirect: "/comprar#/",
          width: "100px",
          widthCell: "70px",
        },
        // {
        //   name: "Red Social",
        //   icon: require("@/assets/img/landing_page/Iconos/Ícono_red social copia@4x.png"),
        //   mode: "social",
        //   width: "100px",
        //   widthCell: "70px",
        //   hideOnCell: true,
        // },
        // {
        //   name: "Precios",
        //   icon: require("@/assets/img/landing_page/Iconos/Ícono_comprar copia@4x.png"),
        //   mode: "prices",
        //   width: "5vw",
        // },
        {
          name: "Plataforma PIE",
          icon: require("@/assets/img/landing_page/Iconos/Landing Page_íconoÍcono_plataforma pie niño inside.svg"),
          mode: "redpie",
          redirect: "/comprar#/",
          width: "100px",
          widthCell: "73px",
        },
      ],
      text: "",
      view_link: "",
      download_link: "",
      bound_rating: 0,
      id: "",
      tags: [],
      rate_loading: false,
      ProfileKey: 0,
      last_notification: null,
      older_notification: null,
      openLogin: null,
      windowWidth: 0,
      redirect_to_tests: false,
      redirect_to_docs: false,
      service: "",
      message: "",
      saveAsImg: require("../../assets/img/save_as.jpg"),
    };
  },
  destroyed: function () {
    if (process.browser) {
      window.removeEventListener("resize", this.set_main_container_position);
    }
  },
  methods: {
    // Whether the top icon strip's bubble for this option is the one currently
    // open — the bubble grows instead of being replaced by a "Volver" button.
    // Active means the real service OR its demo: a visitor landing straight on
    // /eureka-demo from an ad has no `service` set, so route names decide.
    // Almost every mode follows `<mode>` / `<mode>-demo`; "Corregir TEST" keeps
    // the legacy "test-correction" sentinel as its option.mode (changeView /
    // goToServices / the anonymous fromNav list all key off it) while its real
    // route is "corregir-test", and "redpie" only has the pie-demo route (the
    // platform itself lives outside this router, at /redpie#/).
    optionRoutes(mode) {
      const extra = {
        "test-correction": ["corregir-test"],
        redpie: ["pie-demo"],
      };
      return [mode, `${mode}-demo`, ...(extra[mode] || [])];
    },
    isOptionActive(mode) {
      return (
        this.optionRoutes(mode).includes(this.$router.currentRoute.name) ||
        this.service === mode
      );
    },
    // El usuario está dentro de algún servicio (real o demo). Desde ahí las
    // burbujas llevan al servicio que representan, no al teaser de la landing.
    inService() {
      return this.options.some((option) => this.isOptionActive(option.mode));
    },
    // Rutas que abren un servicio (o su demo) como pagina completa. Todas
    // entran igual: la vista queda bajo las burbujas, con el chat arriba.
    isServiceView(name) {
      const rutas = this.options.reduce(
        (acc, option) => acc.concat(this.optionRoutes(option.mode)),
        ["services-details"]
      );
      return rutas.includes(name);
    },
    positionBelowBubbles() {
      if (!this.isServiceView(this.$router.currentRoute.name)) return;
      this.$nextTick(scrollBelowServiceBubbles);
    },
    // Click en una burbuja: la del servicio abierto vuelve a la landing, las
    // demás abren su servicio.
    bubbleClick(mode) {
      if (this.isOptionActive(mode)) {
        this.goHome();
        return;
      }
      this.changeView(mode, true);
    },
    goHome() {
      this.service = "";
      if (this.$router.currentRoute.name !== "home") {
        this.$router.push("home").catch(() => {});
      }
    },
    async preloadMainBanner() {
      await preloadImages([this.mainBanner, this.mainCell]);
      this.bannerLoaded = true;
    },
    checkAndChange() {
      // El modal se cerro: el muro que lo abrio ya no explica lo que pase
      // despues. Si entro, `login_success` ya salio con su `origen_login`; si
      // no entro, arrastrarlo hasta el proximo login de otro dia seria
      // atribuirle una conversion a un muro que esa persona ya olvido.
      olvidarOrigenLogin();
      if (this.$store.state.login.token && this.service) {
        this.changeView(this.service);
        this.service = "";
      }
    },
    goToServices(service) {
      if (service === "materials") {
        this.$toasted.error("Inicia sesión para acceder a esta funcionalidad!");
      } else if (service === "test-correction") {
        this.changeView("test-correction");
        return;
      } else {
        this.service = service;
        this.$router.push("services-details");
      }
    },
    changeView(option, fromNav) {
      // `producto` y no `service`: es la misma clave que usan la ruta
      // `<clave>-demo`, el teaser y las paginas de Django, asi que este evento
      // se puede cruzar con los de la cara publica. `service` viajaba con
      // `redpie` donde el resto dice `pie`, y ademas no estaba registrado como
      // dimension en GA4, o sea que no se perdio ninguna serie al renombrarlo.
      event(
        "select_service",
        conProducto(
          {
            from_nav: !!fromNav,
            logged_in: !!this.$store.state.login.token,
          },
          option
        )
      );
      // Header nav buttons for a logged-out visitor: scroll to that service's
      // banner on the home page instead of opening the demo. The demos stay
      // reachable from each banner's teaser (which calls changeView WITHOUT
      // fromNav). If we're not on home, go home first and then scroll.
      // Excepción: si ya está dentro de un servicio, la burbuja cambia de
      // servicio directamente — mandarlo a leer el teaser sería un paso atrás.
      if (
        fromNav &&
        !this.$store.state.login.token &&
        !this.inService() &&
        [
          "eureka",
          "planification",
          "class-materials",
          "materials",
          "test-correction",
          "individual-documents",
          "redpie",
        ].includes(option)
      ) {
        // Land just BELOW the banner, with the teaser's chat bubble at the top
        // of the viewport (the banner is the poster; the bubble is the pitch).
        // The teaser is the banner's next sibling on the landing page; if the
        // teasers haven't mounted yet, fall back to the banner itself.
        const scrollToService = () => {
          const banner = document.getElementById("banner-" + option);
          if (!banner) return;
          const target = banner.nextElementSibling || banner;
          const header = document.querySelector(".header-general-container");
          const offset = header ? header.offsetHeight : 0;
          window.scrollTo({
            top:
              target.getBoundingClientRect().top + window.pageYOffset - offset,
            behavior: "smooth",
          });
        };
        if (this.$router.currentRoute.name !== "home") {
          this.$router.push("home").catch(() => {});
          // Wait for the landing page (and its banner images) to render.
          setTimeout(scrollToService, 450);
        } else {
          this.$nextTick(scrollToService);
        }
        return;
      }
      // Logged-out visitors get the interactive "try it free" demo of the
      // Individual Documents chatbot instead of the login wall. Remember the
      // intent so that once they log in (from the demo's CTA) `checkAndChange`
      // takes them straight to the real chatbot.
      if (!this.$store.state.login.token && option === "individual-documents") {
        this.service = "individual-documents";
        if (this.$router.currentRoute.name !== "individual-documents-demo") {
          this.$router.push("individual-documents-demo");
        }
        return;
      }
      // Logged-out visitors get the Planifications demo (log in / know more)
      // instead of the login wall. Remember the intent so that once they log in
      // `checkAndChange` forwards them to the real planification chatbot.
      if (!this.$store.state.login.token && option === "planification") {
        this.service = "planification";
        if (this.$router.currentRoute.name !== "planification-demo") {
          this.$router.push("planification-demo");
        }
        return;
      }
      // Logged-out visitors get the Materiales para la clase demo.
      if (!this.$store.state.login.token && option === "class-materials") {
        this.service = "class-materials";
        if (this.$router.currentRoute.name !== "class-materials-demo") {
          this.$router.push("class-materials-demo");
        }
        return;
      }
      // Logged-out visitors get the Eureka demo (log in / know more) instead of
      // the login wall. Remember the intent so that once they log in
      // `checkAndChange` forwards them to the real Eureka chatbot.
      if (!this.$store.state.login.token && option === "eureka") {
        this.service = "eureka";
        if (this.$router.currentRoute.name !== "eureka-demo") {
          this.$router.push("eureka-demo");
        }
        return;
      }
      // Logged-out visitors get the Pruebas Informales demo (log in / know more)
      // instead of the login wall. Remember the intent so that once they log in
      // `checkAndChange` forwards them to the real materials chatbot.
      if (!this.$store.state.login.token && option === "materials") {
        this.service = "materials";
        if (this.$router.currentRoute.name !== "materials-demo") {
          this.$router.push("materials-demo");
        }
        return;
      }
      // Corrección de Tests dejó de ser gratis sin cuenta: corregir de verdad
      // gasta un `tests_uses`. El visitante sin sesión va a la demo —que es el
      // producto entero pregrabado, no un muro— y el corrector real queda
      // detrás del login, como el resto.
      if (!this.$store.state.login.token && option === "test-correction") {
        this.service = "test-correction";
        if (this.$router.currentRoute.name !== "test-correction-demo") {
          this.$router.push("test-correction-demo");
        }
        return;
      }

      // Only paid users reach the platform (/redpie#/). Everyone else — logged
      // out or logged in without a paid school — gets the Sistema PIE demo
      // (know more about each service + unlimited-uses messaging).
      if (option === "redpie" && !this.$store.state.login.isPaid) {
        this.service = "redpie";
        if (this.$router.currentRoute.name !== "pie-demo") {
          this.$router.push("pie-demo");
        }
        return;
      }
      if (
        this.$store.state.login.token ||
        option === "social" ||
        option === "prices" ||
        option === "test-correction"
      ) {
        if (option === "redpie") {
          window.location.href = "/redpie#/";
        } else if (option === "eureka" && this.$store.state.login.isPaid) {
          window.location.href = "/redpie#/eureka";
        } else if (option === "prices") {
          console.log(option);
        } else if (option === "test-correction") {
          // La opcion conserva el `mode` historico "test-correction"; su ruta
          // se llama "corregir-test".
          if (this.$router.currentRoute.name !== "corregir-test") {
            this.$router.push("corregir-test");
          }
        } else {
          if (this.$router.currentRoute.name !== option) {
            this.$router.push(option);
          }
        }
      } else {
        // GO TO SERVICE DETAILS
        // `origen_login` y no `source`: GA4 se reserva ese nombre para la
        // fuente de campana. Ver backend/marketing/analitica.py.
        eventoLogin("login_wall_shown", { origen_login: "service" }, option);
        this.$toasted.success("Inicia sesión para utilizar este servicio!");
        this.goToServices(option);
        this.openLogin(true);
        // GO TO LOGIN
        // this.openLoginTrial();
      }
    },
    closeAndUpdate() {
      userService.alertMessageSeen();
      this.$refs["message-modal"].hide();
    },
    downloaded() {
      fileService.materialDownload();
    },
    setPadding() {
      if (this.windowWidth > 1800) {
        return "big-padding";
      } else if (this.windowWidth > 1500) {
        return "medium-padding";
      }
    },
    setOpenLogin(openFun) {
      this.openLogin = openFun;
    },
    // Qué servicio representa una ruta: la inversa de `optionRoutes`.
    //
    // Hace falta cuando el visitante aterriza directo en una demo desde fuera
    // del SPA: `this.service` está vacío, y sin él `checkAndChange` no lo lleva
    // a ninguna parte cuando termina de entrar. Se queda mirando la demo con la
    // sesión abierta.
    serviceForRoute(name) {
      const option = this.options.find((o) =>
        this.optionRoutes(o.mode).includes(name)
      );
      return option ? option.mode : "";
    },
    // `?login=1` abre la demo con el modal de sesión ya arriba.
    //
    // Las páginas de producto (/eureka/, /documentacion-pie/…) llevan dos botones al mismo sitio:
    // "Inicia sesión y úsalo gratis" apunta acá y "Averigua más aquí" a la demo
    // pelada. Es un parámetro y no una ruta nueva a propósito —la pantalla es
    // la misma—, así que no hay una segunda copia de cada demo que se pueda
    // desincronizar con la primera. Ver `demo_ctas` en backend/marketing/pages.py.
    //
    // Va en `mounted` y no antes: `openLogin` lo entrega HeaderComponent desde
    // su `created`, que corre mientras el padre se monta.
    openLoginFromQuery() {
      if (!this.$route.query.login || !this.openLogin) return;
      // `?login=clave` es la vuelta de «Olvidé mi contraseña», con la clave
      // ya cambiada (backend/api/views_olvide_clave.py): el login con correo
      // y contraseña, sin el aviso de la prueba gratuita.
      if (this.$route.query.login === "clave") {
        this.$toasted.success(
          "Tu contraseña quedó cambiada. Entra con tu correo y la contraseña nueva."
        );
        if (!this.$store.state.login.token) {
          // Muro propio: sin él, los eventos de este login saldrían sin
          // origen o con el de un muro de demo visto antes, y en el informe
          // se mezclarían con las demos.
          eventoLogin("login_wall_shown", { origen_login: "reset" });
          this.openLogin(false);
        }
        return;
      }
      this.openLoginTrial({
        service: this.serviceForRoute(this.$route.name),
        // Con `register` en true el modal esconde el formulario de correo y
        // deja solo Google. Quien llega desde un botón que dice "Inicia
        // sesión" puede tener cuenta hace años, así que se abre con las dos
        // puertas.
        register: false,
      });
    },
    // El payload de `open-login` es opcional: las demos que no lo mandan
    // siguen abriendo el modal en "crear cuenta", como hasta ahora. La de
    // tests manda { register: false } porque ese estado del modal no ofrece
    // correo y contraseña —solo Google— y dejaba sin puerta a quien ya tiene
    // cuenta. Ver LoginModalComponent: `manualRegister` está en false, así que
    // registrarse e ingresar comparten el mismo botón de Google y lo único que
    // el estado de registro agrega es quitar el formulario de correo.
    openLoginTrial(options) {
      // Qué servicio pidió el login. Los teasers de la landing lo mandan en el
      // payload: sin él `this.service` está vacío en la portada, y la rama de
      // "ya tiene sesión" terminaba llamando a changeView("") — el botón
      // "Inicia sesión y haz la tuya!" no hacía absolutamente nada para quien
      // ya estaba registrado.
      const service = (options && options.service) || this.service;
      if (!this.$store.state.login.token) {
        // Se recuerda para que `checkAndChange` lo lleve a su servicio apenas
        // termine de entrar, en vez de dejarlo en la portada.
        this.service = service;
        eventoLogin("login_wall_shown", { origen_login: "trial" }, service);
        this.$toasted.success("Inicia sesión para realizar una prueba gratuita!");
        this.openLogin(!(options && options.register === false));
      } else {
        this.changeView(service);
        this.service = "";
      }
    },
    openRedpieTutorial: function () {
      this.$refs["redpie-tutorial-modal"].open();
    },
    openTutorial: function () {
      this.$refs["tutorial-modal"].open();
    },
    openFeedback: function () {
      this.$refs["feedback-modal"].open();
    },
    openOka() {
      this.$refs["modal-add-grade"].open();
    },
    reload_points: function () {
      userService.get_user_data().then((data) => {
        this.$store.commit("login/setPoints", data, { root: true });
      });
    },
    getUncompletedMissions: function () {
      missionService.getUncompletedMissions().then((data) => {
        this.$store.commit("login/setMissions", data);
      });
    },
    get_posts: function () {
      this.$refs.main.get_posts();
    },
    force_get_posts: function () {
      this.$refs.main.force_get_posts();
    },
    get_files: function () {
      this.$refs.main.reset();
    },
    get_posts_by_tag: function (tag) {
      this.$refs.main.get_posts_by_tag(tag);
    },
    get_posts_by_subtag: function (subtag) {
      if (this.$router.currentRoute.name === "home")
        this.$refs.main.get_posts_by_subtag(subtag);
      else {
        this.$store.commit(
          "login/setSubtag",
          { subtag: subtag },
          { root: true }
        );
        this.$router.push({ name: "home" });
      }
    },
    get_my_notifications: function () {
      notificationService.get_my_notifications().then((data) => {
        const notifications = data.notifications;
        if (notifications.length > 0) {
          this.last_notification = notifications[0];
          this.older_notification = notifications[notifications.length - 1];
        }
        this.$store.commit("login/setNotifications", notifications, {
          root: true,
        });
      });
    },
    get_my_last_notifications: function () {
      notificationService
        .get_my_notifications({
          last: this.last_notification.created_at,
        })
        .then((data) => {
          const notifications = data.notifications;
          if (notifications.length > 0) {
            this.last_notification = notifications[0];
          }
          this.$store.commit("login/addNotification", notifications, {
            root: true,
          });
        });
    },
    get_my_previous_notifications: function () {
      notificationService
        .get_my_notifications({
          previous: this.older_notification.created_at,
        })
        .then((data) => {
          const notifications = data.notifications;
          if (notifications.length > 0) {
            this.older_notification = notifications[notifications.length - 1];
          }
          this.$store.commit("login/pushNotification", notifications, {
            root: true,
          });
        });
    },
    get_new_notifications: function () {
      notificationService.get_new_notifications().then((data) => {
        this.$store.commit(
          "login/setNewNotifications",
          data.new_notifications_count,
          { root: true }
        );
      });
    },
    set_not_new_notifications: function () {
      notificationService.set_not_new_notifications().then((data) => {
        this.$store.commit(
          "login/setNewNotifications",
          data.new_notifications_count,
          { root: true }
        );
      });
    },
    verify_token: function () {
      authService.verify_token().then(
        // eslint-disable-next-line
        (data) => {
          // console.log("verifying token...");
        },
        // eslint-disable-next-line
        (error) => {
          const status = error.response? error.response.status:null;
          if (status === 401 || status === 403) {
            this.$toasted.error("Tu sesión ha expirado.");
            this.$store.commit("login/setUserEmpty", { root: true });
          }
        }
      );
    },
    set_main_container_position() {
      this.windowWidth = window.innerWidth;
      const header = document.querySelector("#header");
      const mainContainer = document.querySelector("#mainContainer");

      if (header && mainContainer) {
        mainContainer.style.paddingTop = `${header.offsetHeight}px`;
      }
    },
    search_by_text: function (text) {
      this.$refs.main.search(text);
    },
    get_tags: function () {
      postService.get_tags().then(
        (data) => {
          this.tags = data.tags;
        },
        (error) => {
          console.error(error);
        }
      );
    },
    view_file: function (links) {
      this.rate_loading = true;
      this.download_link = links.download_link;
      this.view_link = links.view_link;
      this.$bvModal.show("bv-modal-view-file");
      this.id = links.id;
      postService.get_my_file_rate({ id: this.id }).then(
        (data) => {
          this.bound_rating = data.rate;
          this.rate_loading = false;
        },
        // eslint-disable-next-line
        (error) => {
          this.$toasted.error("Ha ocurrido un error obteniendo tu voto.");
          this.bound_rating = 0;
          this.rate_loading = false;
        }
      );
    },
    close_login_dropdown: function () {
      this.$refs.loginDropdown.hide();
    },
    rating_selected: function () {
      postService
        .rate_file({ bound_rating: this.bound_rating, id: this.id })
        .then(
          (data) => {
            this.$toasted.success(data.message);
          },
          // eslint-disable-next-line
          (error) => {
            this.$toasted.error(
              "Ha ocurrido un error guardando tu voto, inténtalo más tarde."
            );
            this.bound_rating = 0;
          }
        );
    },
    createSchool: function () {
      if (
        this.$store.state.login.token === "" ||
        (!this.$store.state.login.school && this.$store.state.login.token)
      ) {
        // var payload = {
        //   socket: (this.$store.state.login.token === ""? this.$store.state.login.anonID : this.$store.state.login.user_id)
        // }
        // this.redirect_to_tests = true;
        // redpieService.createSchool(payload).then(
        //   () => {
        //     this.$refs['loading-modal'].open(true, false, false)
        //   }
        // )
        // console.log("no tiene colegio");
        this.$toasted.error(
          "Necesitas tener un colegio asociado para usar esta funcionalidad!"
        );
      } else {
        if (this.$store.state.login.isPaid) {
          window.location.href = "/redpie#/tutorial";
        } else {
          this.$toasted.error(
            "Necesitas tener acceso a Redpie para usar esta funcionalidad!"
          );
        }
      }
    },
    createSchoolDocs: function () {
      if (
        this.$store.state.login.token === "" ||
        (!this.$store.state.login.school && this.$store.state.login.token)
      ) {
        // var payload = {
        //   socket: (this.$store.state.login.token === ""? this.$store.state.login.anonID : this.$store.state.login.user_id)
        // }
        // this.redirect_to_docs = true;
        // redpieService.createSchool(payload).then(
        //   () => {
        //     this.$refs['loading-modal'].open(true, false, false)
        //   }
        // )
        // console.log("no tiene colegio");
        this.$toasted.error(
          "Necesitas tener un colegio asociado para usar esta funcionalidad!"
        );
      } else {
        if (this.$store.state.login.isPaid) {
          window.location.href = "/redpie#/tutorial-docs";
        } else {
          this.$toasted.error(
            "Necesitas tener acceso a Redpie para usar esta funcionalidad!"
          );
        }
      }
    },
    check_country: function () {
      // if (this.$store.state.login.country < 1) {
      //   this.$nextTick(
      //     () => setTimeout(
      //       () => this.$refs["country-modal"].open(),
      //       2000
      //     )
      //   );
      // }
    },
  },
  watch: {
    bannerLoaded(cargado) {
      // Entrada directa por URL: recien ahi el banner tiene su altura final.
      // Si el usuario ya empezo a bajar, no le movemos la pagina.
      if (cargado && window.pageYOffset === 0) this.positionBelowBubbles();
    },
    // `?login=1` también llega sin recargar: "Probar gratis" en la portada
    // navega con el router, cuando `mounted` ya pasó.
    "$route.query.login"(login) {
      if (login) this.openLoginFromQuery();
    },
    // eslint-disable-next-line
    $route(to, from) {
      this.positionBelowBubbles();
      if (this.$store.state.login.token) {
        this.verify_token();
      }
    },
    // eslint-disable-next-line
    token(new_value, old_value) {
      if (new_value) {
        this.check_country();
        this.get_my_notifications();
        this.$connect(
          process.env.VUE_APP_SOCKET_URL + "/ws/socket/?token=" + new_value
        );
      } else {
        // const current_date = new Date().valueOf().toString();
        // const random = Math.random().toString();
        // this.$store.commit("login/setAnonID", current_date + random, {
        //   root: true,
        // });
        // this.$connect(
        //   process.env.VUE_APP_SOCKET_URL +
        //     `/ws/socket/?token=${this.$store.state.login.anonID}`
        // );
      }
      this.get_tags();
    },
  },
};
</script>

<style lang="scss">
/* Non-scoped: stop the document itself from scrolling horizontally on mobile.
   Scoped selectors can't target html/body, so this lives in its own block. */
html,
body {
  overflow-x: clip;
  max-width: 100%;
}
</style>

<style lang="scss" scoped>
@import "../../assets/scss/colors";
@import "../../assets/scss/main";
@import "../../assets/scss/variables";

.header-margin {
  margin-top: $headerHeight;
  /* Clip any horizontal overflow from the main banner / nav so the page never
     gets an x-axis scrollbar on mobile. */
  overflow-x: clip;
  max-width: 100%;
}

.main-component {
  min-height: 100vh;
  background-color: #ffffff !important;
}
.general-container {
  background-color: #ffffff !important;
  overflow-x: clip;
  max-width: 100%;
}
.global-container {
  overflow-x: clip;
  max-width: 100%;
}
.default-container {
  margin-right: 20px !important;
  margin-left: 20px !important;
  padding-top: 85px !important;
}
.big-padding {
  padding-left: 17rem !important;
  padding-right: 17rem !important;
}
.medium-padding {
  padding-left: 12rem !important;
  padding-right: 12rem !important;
}
body {
  font-family: Ubuntu, "times new roman", times, roman, serif !important;
}
.menu-button {
  cursor: pointer;
  transition: transform 0.2s;
}
.menu-button:hover {
  transform: scale(1.1);
}
/* La burbuja del servicio abierto (real o demo) crece y se queda así: es la
   señal de "estás aquí" y, al tocarla, la vuelta a la landing. */
.menu-button-active,
.menu-button-active:hover {
  transform: scale(1.3);
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.25));
}
/* En celular las burbujas van casi pegadas: crecer 30% las encimaría. */
@media (max-width: 767.98px) {
  .menu-button-active,
  .menu-button-active:hover {
    transform: scale(1.15);
  }
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to,
.slide-fade-leave-active {
  transform: translateX(20px);
  opacity: 0;
}
</style>
